import { z } from 'zod';

/**
 * Login Form Schema (QA #85)
 *
 * Only presence is checked here. The account rule (4–32 characters, QA #71)
 * and the password rule (12+ characters, QA #63) apply when an account or a
 * password is *set*; accounts created before those rules — a shorter
 * password, a name in another script — must still be able to sign in and
 * then be walked through the password-expiry flow (QA #67). The old
 * "3 / 6 characters" limits were neither rule, so the form said one thing
 * and the platform another. Wrong credentials are answered by the backend
 * (INVALID_CREDENTIALS → 「帳號或密碼不正確，請重新輸入」).
 */
export const loginSchema = z.object({
  username: z.string().trim().min(1, '請輸入帳號'),
  password: z.string().min(1, '請輸入密碼'),
});

/**
 * Login Form Data Type
 */
export type LoginFormData = z.infer<typeof loginSchema>;

